import { createContext, use } from 'react';
import type { ReactNode } from 'react';
import type { RuntimeConfig } from '@sf/api';

const RuntimeConfigContext = createContext<RuntimeConfig | null>(null);

/** Provides the `/config.json` values loaded once during bootstrap (see main.tsx). */
export function RuntimeConfigProvider({ config, children }: { config: RuntimeConfig; children: ReactNode }) {
  return <RuntimeConfigContext value={config}>{children}</RuntimeConfigContext>;
}

export function useRuntimeConfig(): RuntimeConfig {
  const ctx = use(RuntimeConfigContext);
  if (!ctx) throw new Error('useRuntimeConfig must be used inside <RuntimeConfigProvider>');
  return ctx;
}
